module.exports = __webpack_public_path__ + "static/media/fabrics.2351b0a5.jpg";